var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"color":"info","dense":"","text":""}},[_vm._v(" O valor fixo será aplicado em caso de uso. ")]),_c('v-text-field',{attrs:{"label":"Valor fixo","type":"number","min":0.01,"step":0.01,"outlined":"","dense":"","prefix":"R$","rules":[
      (v) => !!v || 'Valor fixo é obrigatório',
      (v) => parseFloat(v) > 0 || 'Valor fixo deve ser maior que 0',
      (v) =>
        parseFloat(v) >= 0.01 || 'Valor fixo deve ser maior ou igual a 0.01',
    ],"hide-details":"auto"},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }